var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBitbucketLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77,
    height: 70,
    viewBox: "0 0 77 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "108.633%",
    x2: "46.927%",
    y1: "30.112%",
    y2: "65.817%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "18%",
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2684FF"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.561 46.065h16.027l3.868-22.584H26.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2684FF",
    fillRule: "nonzero",
    d: "M2.684.32A2.457 2.457 0 0 0 .228 3.167l10.426 63.295a3.34 3.34 0 0 0 3.267 2.788h50.02a2.457 2.457 0 0 0 2.455-2.063L76.823 3.18A2.456 2.456 0 0 0 74.367.33L2.684.32zm43.904 45.745H30.623L26.3 23.48h24.156l-3.868 22.584z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "nonzero",
    d: "M74.507 23.48h-23.05l-3.87 22.585H31.624L12.772 68.44a3.33 3.33 0 0 0 2.15.811h50.03a2.457 2.457 0 0 0 2.457-2.063l7.098-43.707z",
    transform: "translate(-1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitbucketLogo);
export default __webpack_public_path__ + "static/media/bitbucket-logo.e9be03a5.svg";
export { ForwardRef as ReactComponent };